
<div class="navbar navbar-default">
    <div class="container-fluid">
        <div class="col-md-12">
            <div class="navbar-header">
                <a  class="navbar-brand">Recipe Book</a>
            </div>
    
            <div class="collapse navbar-collapse">
                <!-- <ul class="nav navbar-nav" (click)="selectedTab($event)">
                    <li><a >Recipes</a></li>
                    <li><a >Shopping List</a></li> -->
                <ul class="nav navbar-nav">
                    <li routerLinkActive="active" *ngIf="isAuthenticated"><a routerLink="/recipes">Recipes</a></li>
                    <li routerLinkActive="active" *ngIf="!isAuthenticated"><a routerLink="/auth">Authenticate</a></li>
                    <li routerLinkActive="active"><a routerLink="/shopping-list">Shopping List</a></li>
                </ul>
                <ul class="nav navbar-nav navbar-right">
                    <li *ngIf="isAuthenticated">
                        <a style="cursor: pointer;" (click)="onLogOut()">Logout</a>
                    </li>
                    <li class="dropdown" appDropdown *ngIf="isAuthenticated">
                        <a style="cursor: pointer;" class="dropdown-toggle" role="button">Manage <span class="caret"></span></a>
                        <ul class="dropdown-menu">
                            <li><a style="cursor: pointer;" (click)="onSave()">Save Data</a></li>
                            <li><a style="cursor: pointer;" (click)="onFetch()">Fetch Data</a></li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
       
    </div>
</div>